import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.css";
import configureStore from "./redux/configureStore";
import Auth from "./Auth";
import { createRoot } from "react-dom/client";

const rootElement = document.getElementById("root");
const store: any = configureStore();

if (rootElement) {
  createRoot(rootElement).render(
    <Provider store={store} {...(null as any)}>
      {" "}
      <BrowserRouter>

        <Auth />
        
      </BrowserRouter>
    </Provider>
  );
}

export { store };
